"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import ReactUtils from "../../react_utils";
import DocumentTitle from "react-document-title";
import ToDashboardWithFilters from "../ui/to_dashboard_with_filters";
import Api from "../../api/api";
const bem = ReactUtils.makeBem("review-groups");
function debtorName(debtorName2) {
  if (debtorName2) {
    return debtorName2;
  } else {
    return "No debtor selected";
  }
}
function invoiceNumber(sourceInvoiceNumber) {
  if (sourceInvoiceNumber) {
    return sourceInvoiceNumber;
  } else {
    return "Not found";
  }
}
function standardGroupDisplay(group) {
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx("h4", { children: `Group ${group.number}` }),
    /* @__PURE__ */ jsxs("div", { className: bem("__typeahead-label-inline"), children: [
      /* @__PURE__ */ jsx("span", { className: "group-field", children: "Invoice #:" }),
      /* @__PURE__ */ jsx("span", { className: "group-value", children: invoiceNumber(group.sourceInvoiceNumber) })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: bem("__typeahead-label-inline"), children: [
      /* @__PURE__ */ jsx("span", { className: "group-field", children: "Debtor:" }),
      /* @__PURE__ */ jsx("span", { className: "group-value", children: debtorName(group.debtorName) })
    ] }),
    group.documents.length > 0 ? group.documents.map((document, index) => {
      return /* @__PURE__ */ jsxs("div", { className: bem("__typeahead-label-inline"), children: [
        /* @__PURE__ */ jsxs("span", { className: "group-field", children: [
          "Document ",
          index + 1,
          ":"
        ] }),
        /* @__PURE__ */ jsx("span", { className: "group-value", children: document["data"]["document_type"] })
      ] }, document.id);
    }) : /* @__PURE__ */ jsxs("div", { className: bem("__typeahead-label-inline"), children: [
      /* @__PURE__ */ jsx("span", { className: "group-field" }),
      /* @__PURE__ */ jsx("span", { className: "group-value", children: "No Documents" })
    ] }),
    /* @__PURE__ */ jsx("hr", {})
  ] }, group.id);
}
function unassociatedGroupDisplay(group) {
  const possiblePluralizedDocument = group.documents.length === 1 ? "Document" : "Documents";
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx("h4", { children: `Unassociated` }),
    /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs("span", { className: "group-value", children: [
      group.documents.length,
      " ",
      possiblePluralizedDocument
    ] }) }),
    /* @__PURE__ */ jsx("hr", {})
  ] }, "unassociated");
}
var ReviewGroups = React.createClass({
  getInitialState: function() {
    return {
      submitting: false
    };
  },
  handleSubmit: function(event) {
    event.stopPropagation();
    event.preventDefault();
    this.setState({ submitting: true });
    Api.DocumentBatches.markInvoicesIndexedAndSendTransmission(
      this.props.documentBatchId
    ).then(() => {
      ToDashboardWithFilters(this.props.location);
    });
  },
  render: function() {
    return /* @__PURE__ */ jsx(
      DocumentTitle,
      {
        "data-component": "ReviewGroups",
        title: "TriumphPay Audit \u2013 Review Invoices",
        children: /* @__PURE__ */ jsxs("div", { className: bem(""), children: [
          /* @__PURE__ */ jsx("h3", { children: "Review" }),
          /* @__PURE__ */ jsx(
            "button",
            {
              onClick: this.handleSubmit,
              disabled: this.state.submitting,
              className: "review-groups__submit",
              children: "Submit"
            }
          ),
          /* @__PURE__ */ jsx("hr", {}),
          this.props.groups.map((group) => {
            if (group.number === "unassociated") {
              return unassociatedGroupDisplay(group);
            } else {
              return standardGroupDisplay(group);
            }
          })
        ] })
      }
    );
  }
});
export default ReviewGroups;
